export default __webpack_public_path__ + "static/media/baitlogo.12a5716d.png";